import { PetsConsultations } from './PetsConsultations';
export default PetsConsultations;
